import { PropsWithChildren } from 'react';
import s from './PublicPageLayout.module.scss';

export default function PublicPageLayout({ children }: PropsWithChildren) {
  return <div className={s.wrapper}>{children}</div>;
}
